import { render } from "./all-internal-issues.vue?vue&type=template&id=8703e918&scoped=true"
import script from "./all-internal-issues.vue?vue&type=script&lang=js"
export * from "./all-internal-issues.vue?vue&type=script&lang=js"

import "./all-internal-issues.vue?vue&type=style&index=0&id=8703e918&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8703e918"]])

export default __exports__